import React, {Component} from 'react';
import {SelectWithSearch} from "./SelectWithSearch";
import { withTranslation } from 'react-i18next';

export const SPECIAL_ITEM_CONNECT_NEW_STORE = "CONNECT_NEW_STORE";

export const CHANNEL_STORE_SELECT_SPECIAL_ITEMS = [SPECIAL_ITEM_CONNECT_NEW_STORE];

export const DATA_BY_SPECIAL_ITEM = {
    [SPECIAL_ITEM_CONNECT_NEW_STORE]: {
        text: "[Conectar con una tienda nueva]",
        className: "special-item"
    }
};

export class ChannelStoreSelectClass extends Component {
    constructor(props) {
        super(props);

        this.handleSelectedOptionChange = this.handleSelectedOptionChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            selectedStore: this.props.selectedStore
        })
    }

    getNotSelectableOptions(){
        return [];
    }

    handleSelectedOptionChange(newOption) {
        const selectedStoreId = newOption.id;
        const selectedStoreName = newOption.text !== null ? newOption.text.split(" (")[0] : null;

        this.props.onStoreChange(selectedStoreId, selectedStoreName)
    }

    hasNotAccess(store) {
        if(store.has_access === undefined)
            return false;

        if(store.has_access === null)
            return false;

        return !store.has_access;
    }

    convertStoresToSelectOptions () {
        const { t } = this.props;
        if(!this.props.allStores)
            return [];

        return this.props.allStores.map((store) => {
            return {
                "id": store["id"],
                "text": store["name"] +" (ID: " + store["id"] + ")" + (this.hasNotAccess(store)? `  [${t('channel_store_select.no_connection')}]` : ""),
            };
        });
    }

    addConnectNewStoreOption(options) {
        const { t } = this.props;
        if(this.props.canCreateNewStore !== true)
            return;

        const newStoreOption = {
            id: SPECIAL_ITEM_CONNECT_NEW_STORE,
            text: t('channel_store_select.connect_new_store'),
            className: "special-item"
        };

        options.unshift(newStoreOption);
    }

    render() {
        const { t } = this.props;
        if (this.props.allStores !== null) {
            const options = this.convertStoresToSelectOptions();
            this.addConnectNewStoreOption(options);
            return <SelectWithSearch
                                    blackSelection={this.props.blackSelection}
                                     optionosNotSelectable={this.getNotSelectableOptions()}
                                     options={options}
                                     selected={this.props.selectedStore}
                                     onSelectOptionChange={this.handleSelectedOptionChange}
                                     showFormValidationTexts={this.props.showFormValidationTexts}
                                     optionsVersion={this.props.channel}
            />
        } else {
            return <p>{t('common.loading')}</p>
        }
    }
}

export const ChannelStoreSelect = withTranslation()(ChannelStoreSelectClass);
export default ChannelStoreSelect;
